import { Injectable } from '@angular/core';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { ReplaySubject } from 'rxjs';
import {log} from '../functions';

@Injectable({
  providedIn: 'root'
})
export class NotifierWrapService {
  public notify$: ReplaySubject<any> = new ReplaySubject();
  private lastMessage: string;
  private lastMessageTime: number;
  private audio: HTMLAudioElement[] = [];
  constructor(
    // public allService: AllService,
    public service: SnotifyService
  ) {}

  public onMessagePlay() {
    log('onMessagePlay');
    // const audioPlayerRef.nativeElement.audio.volume = 0.5;
    this.playAudio('new_message');
  }

  public isFocused() {
    return document.hasFocus();
  }
  public notify(
    type: 'error' | 'success' | 'info' | 'warning' = 'error',
    message = 'Произошла ошибка.',
    position: SnotifyPosition = SnotifyPosition.centerTop,
    timeout = 5000
  ) {
    if (this.lastMessage !== message || !this.lastMessageTime || this.lastMessageTime < Date.now() - 5000) {

      this.lastMessage = message;
      this.lastMessageTime = Date.now();
      switch (type) {
        case 'error':
          this.service.error(message, {
            timeout: timeout,
            showProgressBar: false,
            position: position,
            closeOnClick: true,
            pauseOnHover: false
          });
          if (this.isFocused()) {
            this.playAudio('alert');
          }
          break;
        case 'success':
          this.service.success(message, {
            timeout: timeout,
            showProgressBar: false,
            position: position,
            closeOnClick: true,
            pauseOnHover: false
          });
          this.playAudio('open');
          break;
        case 'info':
          this.service.info(message, {
            timeout: timeout,
            showProgressBar: false,
            position: position,
            closeOnClick: true,
            pauseOnHover: false
          });
          this.playAudio('open');
          break;
        case 'warning':
          this.service.warning(message, {
            timeout: timeout,
            showProgressBar: false,
            position: position,
            closeOnClick: true,
            pauseOnHover: false
          });
          if (this.isFocused()) {
            this.playAudio('alert');
          }
          break;
      }

      // this.notifier.notify(type, message);
      // TODO не сразу добавляется уведомление
    }
  }
  public playAudio(name: string, loop = false, volume = 0.5): void {
    const audio = new Audio();
    audio.src = `/assets/sound/${name}.mp3`;
    audio.loop = loop;
    audio.volume = volume;
    audio.load();
    audio.play();
    this.audio.push(audio);
  }
  public stopAudio(): void {
    this.audio.map((audio) => {
      audio.pause();
      audio.currentTime = 0;
    })
  }
}
